import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAppointmentStore } from '../../store.ts'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireReferral?: boolean
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireReferral = false,
}) => {
  const location = useLocation()
  const { zdCode } = useAppointmentStore()

  if (requireReferral && !zdCode) {
    return <Navigate to="/referral/book" replace state={{ from: location }} />
  }

  return <>{children}</>
}

export { ProtectedRoute }
